module.exports = __webpack_public_path__ + "img/vertical_3_7_9005.f9b17bad.png";